// RSVP flow utilities for events page
export const PENDING_RSVP_URL_KEY = 'pending_rsvp_url';
export const PENDING_RSVP_RETURN_URL_KEY = 'pending_rsvp_return_url';
export const RSVP_COMMUNITY_TAG = 'rsvp-community';

/**
 * Removes RSVP tokens from sessionStorage
 * Called when user closes the sign-in modal without completing signup
 */
export const removeRsvpTokens = () => {
  window.sessionStorage.removeItem(PENDING_RSVP_URL_KEY);
  window.sessionStorage.removeItem(PENDING_RSVP_RETURN_URL_KEY);
};

/**
 * Gets RSVP tokens from sessionStorage
 */
export const getRsvpTokens = () => ({
  pendingRsvpUrl: window.sessionStorage.getItem(PENDING_RSVP_URL_KEY),
  returnUrl: window.sessionStorage.getItem(PENDING_RSVP_RETURN_URL_KEY),
});

/**
 * Sets RSVP tokens in sessionStorage
 */
export const setRsvpTokens = (url: string) => {
  window.sessionStorage.setItem(PENDING_RSVP_URL_KEY, url);
  window.sessionStorage.setItem(PENDING_RSVP_RETURN_URL_KEY, window.location.pathname);
};

/**
 * Checks if user should receive the RSVP community tag
 * Returns true if user signed up from the RSVP modal on the events page
 */
export const addRsvpTag = (): boolean => {
  const rsvpReturnUrl = window.sessionStorage.getItem(PENDING_RSVP_RETURN_URL_KEY);
  if (!rsvpReturnUrl) return false;

  try {
    const url = new URL(rsvpReturnUrl, window.location.origin);
    const pathname = url.pathname || '';
    return pathname.endsWith('/pages/alo-events');
  } catch (e) {
    // If URL parsing fails, silently skip RSVP tagging
    return false;
  }
};
